import { get } from 'lodash-es';
import { TableColumn, TableRow } from '@app/types/table';

export const getTableDataKey = <T>(header: TableColumn<T>): string => {
  return `data-key-field-${header.id}`;
};

export const getTableCellData = <T>(
  header: TableColumn<T>,
  row: T,
): string | number | React.ReactNode => {
  // Use transformer if available
  if (header.transformers?.data) {
    return header.transformers.data(row, header);
  }

  // Use dataKeys if available
  if (header.dataKeys) {
    const value = get(row, header.dataKeys, null);
    return typeof value === 'string' && value.trim() === '' ? null : value;
  }

  return null;
};

export const getTableData = <T>(headers: TableColumn<T>[], rows: T[]): TableRow[] => {
  return rows.map((row) => {
    const response: TableRow = {};

    headers.forEach((header) => {
      const value = header.transformers?.data
        ? header.transformers.data(row, header)
        : header.dataKeys
        ? get(row, header.dataKeys, null)
        : null;

      response[getTableDataKey(header)] = {
        value: value,
      };
    });

    return response;
  });
};

export const getTableClassName = <T>(
  header: TableColumn<T>,
  type: 'header' | 'row' | 'line-item',
): string => {
  return `${type}-field-${header.id}`;
};
